import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { reduxForm, getFormValues, Field, reset } from 'redux-form'
import { Confirm, Modal, Button } from 'semantic-ui-react'
import r from 'reactotron-react-js'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, ModalAction } from './styled'
import {
  fetchUsersRole,
  createProjectUser,
  updateProjectUser,
  deleteProjectUser,
} from 'ducks/roleMan'
import { fetchGoasProject } from 'ducks/goa'

import { Toaster } from '@blueprintjs/core'
let toast = Toaster.create({ message: '', show: false })

const FormProjectUser = props => {
  const {
    handleSubmit,
    valueForm,
    show,
    title,
    changeShow,
    showConfirm,
    setShowConfirm,
    loading,
    loadingProject,
  } = props
  const onDataCreated = (pageSize, setCurrentPage) => itemCount => {
    r.log({ pageSize, setCurrentPage, itemCount })
    if (itemCount <= pageSize) {
      setCurrentPage(0)
    } else {
      let targetPage = Math.ceil(itemCount / pageSize)
      setCurrentPage(targetPage - 1)
    }
  }
  return (
    <div>
      <Modal
        size="tiny"
        open={show}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        onMount={() => onModalMount()}
      >
        <Modal.Header>{title || ''}</Modal.Header>
        <Modal.Content>
          <form onSubmit={handleSubmit(() => setShowConfirm(true))}>
            <Cont>
              <React.Fragment>
                <Field
                  name="projectId"
                  label="Project"
                  loading={loadingProject}
                  options={props.goasProject}
                  type={type.select}
                  component={FieldInput}
                  require
                  placeHolder={'Select Project'}
                />
                <Field
                  name="users"
                  label="Users"
                  multiple
                  loading={loading}
                  options={props.usersRole}
                  type={type.select}
                  component={FieldInput}
                  require
                  placeHolder={'Select Users'}
                />
              </React.Fragment>
            </Cont>
            <ModalAction>
              {!props.isCreate && (
                <Button
                  onClick={() => props.setIsDelete(true)}
                  type="submit"
                  negative
                >
                  <i className="trash alternate icon"></i>
                  Delete
                </Button>
              )}
              <Button
                onClick={() => closeModal()}
                color={props.isCreate ? 'red' : 'yellow'}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                positive
                labelPosition="right"
                icon="save"
                content="Save"
                onClick={() => props.setIsDelete(false)}
              />
            </ModalAction>
          </form>
        </Modal.Content>
      </Modal>
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => submitModal()}
      />
    </div>
  )
  function submitModal() {
    setShowConfirm(false)
    const projectName = props.goasProject.find(
      item => item.value === valueForm.projectId
    )
    if (props.isCreate) {
      let users = props.valueForm.users.map((item, index) => ({
        userName: item,
      }))
      let project = props.projectUsers.find(
        item => item.projectId === props.valueForm.projectId
      )
      if (project) {
        let duplicateUser = '',
          addUser = []
        users.forEach(user => {
          let t = project.users.find(item => item.userName === user.userName)
          if (t) {
            duplicateUser += t.userName + '\n'
          } else {
            addUser.push(user)
          }
        })
        if (duplicateUser) {
          duplicateUser += ' was already'
          toast.clear()
          toast.show({
            message: duplicateUser,
            intent: 'warning',
            timeout: 10000,
          })
        }
        if (addUser.length) {
          props.createProjectUser(
            {
              projectId: valueForm.projectId,
              projectName: projectName.text,
              users: addUser,
            },
            closeModal,
            onDataCreated(props.tablePageSize, props.setCurrentPage)
          )
        }
        closeModal()
      } else {
        props.createProjectUser(
          {
            projectId: valueForm.projectId,
            projectName: projectName.text,
            users: users,
          },
          closeModal,
          onDataCreated(props.tablePageSize, props.setCurrentPage)
        )
      }
      // onDataCreated(props.tablePageSize, props.setCurrentPage)
    } else if (props.isDelete) {
      // props.deleteProjectUser(data.id,closeModal)
    } else {
      // props.updateProjectUser(
      //   {
      //     id: data.id,
      //     projectId: valueForm.projectId,
      //     projectName: projectName.text,
      //     users: valueForm.users,
      //     isDelete: false
      //   },
      //   closeModal
      // );
    }
  }

  function closeModal() {
    changeShow()
    props.dispatch(reset('FormProjectUser'))
  }

  function onModalMount() {
    props.fetchUsersRole()
    props.fetchGoasProject()
  }
}

const validate = values => {
  const errors = {}
  if (!values.projectId) {
    errors.projectId = 'Required!'
  }
  if (!values.users) {
    errors.users = 'Required!'
  }
  return errors
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      // projectId: props.data ? props.data.projectId : 0,
      // users: props.data ? props.data.users : 0
    },
    valueForm: getFormValues('FormProjectUser')(state),
    goasProject: state.goa.goasProject
      ? state.goa.goasProject.map(item => ({
          value: item.id,
          text: item.projectName,
        }))
      : [],
    usersRole: state.roleMan.usersRole
      ? state.roleMan.usersRole.map(item => ({
          value: item.username,
          // text: item.username
          // FIXME: Wait to FIX Database
          text: item.fullName,
        }))
      : [],
    loading: state.roleMan.loading,
    loadingProject: state.goa.specialApprovalLoading,
    projectUsers: state.roleMan.projectUsers,
  }
}

const mapDispatchToProps = {
  fetchGoasProject,
  fetchUsersRole,
  createProjectUser,
  updateProjectUser,
  deleteProjectUser,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'FormProjectUser',
    validate: validate,
    enableReinitialize: true,
  }),
  withState('showConfirm', 'setShowConfirm', false),
  withState('isDelete', 'setIsDelete', false),
  lifecycle({
    componentDidMount() {
      this.props.fetchGoasProject()
      this.props.fetchUsersRole()
    },
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(FormProjectUser)
